import type { TFunction } from 'i18next'
import { Popover, PLACEMENT } from 'baseui/popover'
import { ChevronDown } from 'baseui/icon'
import PoleIcon from './PoleIcon'
import PolePickerMenu from './PolePickerMenu'
import type { SalesPole } from './poles'
import usePolePicker from './usePolePicker'
import {
  PoleChevron,
  PoleIconTile,
  PoleTrigger,
  PoleTriggerLabel,
  PoleTriggerText,
  PoleTriggerValue,
} from './styled-components'

interface PolePickerProps {
  t: TFunction
  poles: SalesPole[]
  pole: SalesPole | null
  countOf: (pole: SalesPole) => number
  onSelect: (id: string) => void
}

const PolePicker = ({ t, poles, pole, countOf, onSelect }: PolePickerProps) => {
  const { isOpen, menuWidth, toggle, close, options, popoverOverrides, onMenuKeyDown, myPoleLabel, triggerValue } =
    usePolePicker({ t, poles, pole, countOf, onSelect })

  return (
    <Popover
      isOpen={isOpen}
      placement={PLACEMENT.bottomLeft}
      onClickOutside={close}
      onEsc={close}
      onClick={toggle}
      overrides={popoverOverrides}
      content={<PolePickerMenu label={myPoleLabel} width={menuWidth} options={options} onKeyDown={onMenuKeyDown} />}
    >
      <PoleTrigger type='button' aria-haspopup='listbox' aria-expanded={isOpen} $open={isOpen} $missing={!pole}>
        <PoleIconTile $onTint={!isOpen}>
          <PoleIcon id={pole?.id} size={20} />
        </PoleIconTile>
        <PoleTriggerText>
          <PoleTriggerLabel>{myPoleLabel}</PoleTriggerLabel>
          <PoleTriggerValue $placeholder={!pole}>{triggerValue}</PoleTriggerValue>
        </PoleTriggerText>
        <PoleChevron $open={isOpen}>
          <ChevronDown size={20} color='currentColor' />
        </PoleChevron>
      </PoleTrigger>
    </Popover>
  )
}

export default PolePicker
